<template>
	<div class="hiq-digital-resources__search-field hiq-search-field">
    <label
      class="hiq-digital-resources__search-field-label hiq-search-field__label"
      for="searchField">
        Sök efter verktyg
    </label>
    <input
      id="searchField"
      class="hiq-digital-resources__search-field-input hiq-search-field__input"
      type="text"
      name="query"
      autocomplete="off"
      v-model="query"
      @keyup.enter="search(query)"
    />
    <button
      class="hiq-digital-resources__search-field-btn hiq-search-field__btn"
      type="button"
      aria-label="Sök"
      @click="search(query)">
      <span class="env-assistive-text">
          Sök på digitala lärresurser
      </span> 
    </button>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { IState } from '../store/state';
import { search } from '../store/actions'

interface ISearchFieldData {
  query: string;
}

interface ISearchFieldComputed {
  getQuery: string;
  initialNumberToShow: number;
}

interface ISearchFieldMethods {
  search(query: string): void;
}

export default Vue.extend<ISearchFieldData ,ISearchFieldMethods ,ISearchFieldComputed ,{} >({
	name: 'SearchField',

  data() {
    return { 
      query: '',
    }
  },

  computed: {
    initialNumberToShow() {
      return (this.$store.state as IState).initialNumberToShow;
    },
    getQuery() {
      return this.$store.getters.query;
    },
  },

  methods: {
    search(query: string) {
      this.$store.commit({
        type: 'setQuery',
        payload: query,
      })

      this.$store.commit({
        type: 'setNumberToShow',
        payload: this.initialNumberToShow,
      })
      this.$store.dispatch(search(''));
    },
  },

  mounted() {
    if(this.getQuery && this.getQuery !== ""){
      this.query = this.getQuery;
      this.$store.dispatch(search(''));
    }
  }
})
</script>
